export default __webpack_public_path__ + "static/media/icon_chevron.cb5e35b2.svg";